<template>
  <div class="i_box02" style="margin-top: 40px;">
    <div class="mauto">
      <div class="i_xyhz">
        <div class="title03">
          <h3>想要了解更多科技资讯请关注中国科学资讯网</h3>
          <span><a href="/" class="more">MORE</a></span>
        </div>
        <div class="i_xyhz_l" style="visibility: visible; overflow: hidden; position: relative; z-index: 2; left: 0px;">
          <ul style="margin: 0px; padding: 0px; position: relative; list-style-type: none; z-index: 1;"></ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer clearfix" style="width: 100%;color: #797979;font-size: 14px;line-height: 30px;">
    <div class="mauto" style="display: flex;flex-direction: column;align-items: flex-start;justify-content: flex-start">
      <p> Copyright © 中国科学资讯网 All Rights Reserved</p>
      <p> 技术支持：盒子科技</p>
      <p> 版权声明：本网站所刊内容未经本网站及作者本人许可，
        不得下载、转载或建立镜像等，违者本网站将追究其法律责任。本网站所用文字图片部分来源于公共网络或者素材网站，凡图文未署名者均为原始状况，但作者发现后可告知认领，我们仍会及时署名或依照作者本人意愿处理，如未及时联系本站，本网站不承担任何责任。</p>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Footer"
}
</script>

<style scoped>

</style>